import { h } from "@stencil/core";

const RowShimmer = () => (
  <div class="shimmer-container">
    <div class="shimmer shimmer-row">
      <div class="apps">
        <div class="app-1"></div>
        <div class="app-2"></div>
      </div>
      <div class="content">
        <div class="title"></div>
        <div class="subtitle"></div>
      </div>
    </div>
  </div>
);

export default RowShimmer;
